import axios from 'axios'
import MyCookie from 'Scripts/utils/Cookie'

export default class sms {

  constructor({ selector, to, msg }) {
    this.selector = selector
    this.to = to
    this.msg = msg
    // console.log(this.to, this.msg)
    this.to && this.msg && this.send()
  }

  send() {

    let data = JSON.stringify({
      "messages": [
        {
          "from": "Madmoun",
          "destinations": [
            {
              "to": this.to
            }
          ],
          "text": this.msg
        }
      ]
    })

    let config = {
      method: 'post',
      url: 'https://dmrd81.api.infobip.com/sms/2/text/advanced',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `App ${process.env.INFOBIP}`,
      },
      data: data
    };

    axios(config)
      .then((response) => {
        let smsInfo = MyCookie.getCookie('smsInfo')   
        smsInfo = smsInfo === null ? 0 : parseInt(smsInfo)
        smsInfo += 1
        MyCookie.setCookie('smsInfo', smsInfo, 30)

        this.selector.parentNode.innerHTML = `Un SMS a été envoyé`
      })
      .catch((error) => {
        this.selector.parentNode.innerHTML = `Erreur d'envoi de SMS`
      })

  }
}